var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTopRight = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03127 2.40039H20.7679C21.227 2.40039 21.5996 2.77298 21.5996 3.23206V15.9687C21.5996 16.4278 21.227 16.8004 20.7679 16.8004C20.3089 16.8004 19.9363 16.4278 19.9363 15.9687V4.06372H8.03127C7.5722 4.06372 7.19961 3.69113 7.19961 3.23206C7.19961 2.77298 7.5722 2.40039 8.03127 2.40039Z",
    fill: "#5C5F62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7532 10.5212L5.58463 19.6898C5.23316 20.0412 4.66331 20.0412 4.31184 19.6898V19.6898C3.96037 19.3383 3.96037 18.7684 4.31184 18.417L13.4804 9.2484L11.5712 7.33921L16.656 7.34557L16.6624 12.4304L14.7532 10.5212Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTopRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/top-right.8b8841de.svg";
export { ForwardRef as ReactComponent };